/** Default maximum content width (px) for the central column of the three-column layout */
export const DEFAULT_MAX_CONTENT_WIDTH = 1040;

/** Default sidebars width (px) for side columns of the three-column layout */
export const DEFAULT_SIDEBAR_WIDTH = 200;
